// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"92fc9d04","54":"a563923c","166":"27b0d9d9","302":"9e574efb","336":"9e34be9d","917":"06327982"}[chunkId] + ".css";
};